import type { SideNavV2Item } from "@/components/interactive/SideNavV2";

// Route ids whose sidebar row lives under a different id than the route's parent group.
const PROJECT_NAVBAR_ACTIVE_ITEM_ALIASES: Readonly<Record<string, string>> = {
  models: "model-registry",
  "sql-explorer": "explorer-sql",
  traces: "traces-nav",
};

export const aliasProjectNavItemId = (itemId: string | undefined): string | undefined =>
  itemId == null ? undefined : PROJECT_NAVBAR_ACTIVE_ITEM_ALIASES[itemId] ?? itemId;

export const getSideNavPointerTargetId = (item: SideNavV2Item<string>) => {
  if (item.childrenDisplay === "menu") {
    return item.id;
  }

  return item.children?.[0]?.id ?? item.id;
};

/** The row a route's item id lands on: a parent resolves to its first page, unless it shows its
 *  pages as a menu. */
export const resolveSideNavPointerActiveItemId = (
  items: readonly SideNavV2Item<string>[],
  activeItemId: string | undefined,
): string | undefined => {
  if (activeItemId == null) return undefined;

  for (const item of items) {
    if (item.id === activeItemId) {
      return getSideNavPointerTargetId(item);
    }

    const childActiveItemId = resolveSideNavPointerActiveItemId(item.children ?? [], activeItemId);
    if (childActiveItemId != null) {
      return childActiveItemId;
    }
  }

  return undefined;
};
